import React, { useState, useEffect, useRef } from "react";
import { FaChevronDown } from "react-icons/fa";

function Sarlavha({ chap = "", ong = "", activeSectionId, sectionsList = [], onSectionChange, children }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown if clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div className="qiymat-sarlavha-quti" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 1vw', height: '7.5vh', position: 'relative' }}>

      {/* Left Side - Topic Name (Dropdown) */}
      <div className="qiymat-sarlavha-mavzu" style={{ flex: 1, textAlign: 'left', position: 'relative' }} ref={dropdownRef}>
        <div
          onClick={() => sectionsList.length > 0 && setIsOpen(!isOpen)}
          style={{
            margin: 0,
            color: 'rgb(141, 71, 21)',
            fontSize: '1.2vw',
            fontFamily: 'Roboto Mono, monospace',
            cursor: sectionsList.length > 0 ? 'pointer' : 'default',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }}
        >
          {chap}
          {sectionsList.length > 0 && <FaChevronDown style={{ fontSize: '0.8em', transition: 'transform 0.3s', transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }} />}
        </div>

        {/* Dropdown Menu */}
        {isOpen && sectionsList.length > 0 && (
          <div style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            background: '#fff',
            border: '1px solid #ddd',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            zIndex: 1000,
            maxHeight: '300px',
            overflowY: 'auto',
            minWidth: '250px',
            padding: '5px 0'
          }}>
            {sectionsList.map((sec) => (
              <div
                key={sec.id}
                onClick={() => {
                  if (!sec.is_locked) {
                    onSectionChange(sec.id);
                    setIsOpen(false);
                  }
                }}
                style={{
                  padding: '12px 20px',
                  cursor: sec.is_locked ? 'not-allowed' : 'pointer',
                  background: activeSectionId == sec.id ? 'rgba(141, 71, 21, 0.08)' : (sec.is_locked ? '#f9f9f9' : 'transparent'),
                  color: activeSectionId == sec.id ? 'rgb(141, 71, 21)' : (sec.is_locked ? '#aaa' : '#444'),
                  transition: 'all 0.2s ease',
                  fontWeight: activeSectionId == sec.id ? '600' : 'normal',
                  fontSize: '1vw',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  borderBottom: '1px solid #f0f0f0',
                  opacity: sec.is_locked ? 0.7 : 1
                }}
                onMouseEnter={(e) => {
                  if (activeSectionId != sec.id && !sec.is_locked) e.currentTarget.style.background = '#fafafa';
                }}
                onMouseLeave={(e) => {
                  if (activeSectionId != sec.id && !sec.is_locked) e.currentTarget.style.background = (sec.is_locked ? '#f9f9f9' : 'transparent');
                }}
              >
                <span>
                  {sec.id}. {sec.nomi}
                  {sec.is_locked && <span style={{ marginLeft: '8px', fontSize: '0.8em' }}>🔒</span>}
                </span>
                {sec.count !== undefined && (
                  <span style={{
                    fontSize: '0.8em',
                    background: activeSectionId == sec.id ? 'rgb(141, 71, 21)' : '#eee',
                    color: activeSectionId == sec.id ? '#fff' : '#888',
                    padding: '2px 8px',
                    borderRadius: '12px',
                    fontWeight: 'bold'
                  }}>
                    {sec.count}
                  </span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Center Content (Timer) */}
      <div style={{ flex: 0 }}>
        {children}
      </div>

      <div className="qidiruv-input" style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
        <div className="qiymat-sarlavha-soni">
          <p style={{ margin: 0, color: 'rgb(141, 71, 21)', fontSize: '1.2vw', fontFamily: 'Roboto Mono, monospace' }}>{ong}</p>
        </div>
      </div>
    </div>
  );
}
export default Sarlavha;
